
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <form data-vv-scope="forgot">
          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col lg:block lg:w-1/2">
               <img src="@/assets/images/logo/web-logo.png" alt="login" style="width:350px;" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">

                   <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>
                <div>
                  <vs-input
                  placeholder="Enter email"
                      name="email"
                      type="email"
                      data-vv-name="Email"
                      v-validate="'required|email'"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full"/><div v-if="errors.has('forgot.Email')"
                          style="color:red;"
                        class="invalid-feedback">{{ errors.first('forgot.Email') }}</div>
                     
                      <br>
                      
                    
                      <vs-button type="border" to="/" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                      <vs-button @click="submit" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Reset Password</vs-button>
                    <br><br>

                </div>

              </div>
            </div>
          </div>
          </form>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {ForgotPassword} from '@/api/auth'

export default{
  name: 'forgot-password',
  components: {
  },
  data () {
    return {
      email: '',
      error: false
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll('forgot').then(response => {
        if (response) {
           const payload = {
            email: this.email
          }
          const data = ForgotPassword(payload)
          this.showSuccessMessage('Success','Email sent successfully','success')
          //this.$router.push({name: 'password-setup', params: { email: this.email }}).catch(() => {})

        } else {
          this.showSuccessMessage('Error','Invalid Email','danger')
        }
      })
    

    }
  }
}
</script>

<style lang="scss">


</style>
